/**
 * The disc a name is drawn in when there is no photograph.
 *
 * Picked from the name rather than stored on the record, so the same person is
 * the same colour on every screen they appear on without the backend having to
 * carry a field for it. Five tints, all of them pale enough for the initial to
 * hold its contrast — this is decoration, and nothing in the panel means
 * anything by which colour a disc came out.
 */
const AVATAR_TINTS = [
  "bg-[#DDF3E4] text-[#2F8E5B]",
  "bg-[#DEEBFB] text-[#2F6BAE]",
  "bg-[#EDE7F6] text-[#5B3FA8]",
  "bg-[#FDF0DC] text-[#B4761A]",
  "bg-[#E6FAFB] text-[#00899B]",
];

export const avatarTintFor = (name: string): string => {
  const sum = name
    .split("")
    .reduce((total, char) => total + char.charCodeAt(0), 0);

  return AVATAR_TINTS[sum % AVATAR_TINTS.length];
};

export default avatarTintFor;
